import React from 'react';
import PropTypes from 'prop-types';
import {
  MuiThemeProvider,
  createTheme,
  createGenerateClassName,
  jssPreset,
  StylesProvider,
} from '@material-ui/core/styles';
import { create as createJss } from 'jss';
import aulaTheme from '../../themes/default';

const generateClassName = createGenerateClassName({
  productionPrefix: 'aulaui-mui',
});
const JssInstance = createJss({
  ...jssPreset(),
  insertionPoint: 'custom-insertion-point',
});

// Setup the basic MUI theme for Aula
const MUI_AULA_THEME = {
  typography: {
    fontFamily: aulaTheme.font.family.workSans,
    fontWeightRegular: aulaTheme.font.weight.regular,
    fontWeightMedium: aulaTheme.font.weight.medium,
    fontWeightBold: aulaTheme.font.weight.bold,
    useNextVariants: true,
  },
  palette: {
    primary: {
      light: aulaTheme.color.designSystem.purple60,
      main: aulaTheme.color.designSystem.purple70,
      dark: aulaTheme.color.designSystem.purple80,
      contrastText: aulaTheme.color.black,
    },
    secondary: {
      light: aulaTheme.color.white,
      main: aulaTheme.color.grayLight,
      dark: aulaTheme.color.gray,
      contrastText: aulaTheme.color.black,
    },
    text: {
      hint: aulaTheme.color.grey11,
    },
  },
};

const muiAulaTheme = createTheme(MUI_AULA_THEME);

const MuiProvider = ({ theme, children }) => (
  <StylesProvider jss={JssInstance} generateClassName={generateClassName}>
    <MuiThemeProvider theme={theme || muiAulaTheme}>
      {children}
    </MuiThemeProvider>
  </StylesProvider>
);

MuiProvider.defaultProps = {
  theme: null,
};

MuiProvider.propTypes = {
  theme: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  children: PropTypes.node.isRequired,
};

export default MuiProvider;
